import GLightbox from 'glightbox';

const videoPlayer = () => {

    const videoWrappers = document.getElementsByClassName('video-wrapper');
    const youtubeBtn    = document.getElementsByClassName('youtube-player');

    if(youtubeBtn) {
        for(var j = 0; j < youtubeBtn.length; j++) {
            youtubeBtn[j].addEventListener('click', function(el) {
                el.preventDefault();
                let thisLink = this.getAttribute("href");

                const myGalleryBtn = GLightbox({
                    touchNavigation: true,
                    loop: true,
                    // autoplayVideos: true,
                    elements: [
                        {
                            'href': thisLink,
                            'type': 'video',
                            'source': 'youtube', //vimeo, youtube or local
                            'width': 900,
                        }
                    ],
                    autoplayVideos: true,
                });
                myGalleryBtn.open();
            })
        }
    }

    if(videoWrappers) {
        // glightbox popup
        for(var i = 0; i < videoWrappers.length; i++) {
            videoWrappers[i].addEventListener('click',function() {
                const myGallery = GLightbox({
                    touchNavigation: true,
                    loop: true,
                    autoplayVideos: true,
                    elements: [
                        {
                            'href': this.dataset.src,
                            'type': 'video',
                            'source': 'youtube', //vimeo, youtube or local
                            'width': 900,
                        }
                    ],
                    autoplayVideos: true,
                });
                myGallery.open();
            })
        }
    }

}

export default videoPlayer;